import {MatTooltipDefaultOptions} from '@angular/material/tooltip';

// Shared MAT_TOOLTIP_DEFAULT_OPTIONS used at the app root and spread into any
// component-level override. Component-level providers replace the global one
// entirely, so components that only want to tweak `position` must spread these
// defaults in or sidebar tooltips appear instantly (MAP-1496).
export const TOOLTIP_BASE_OPTIONS: MatTooltipDefaultOptions = {
  showDelay: 1000,
  hideDelay: 0,
  touchendHideDelay: 1000,
};
